import React from 'react';
import { FileText, Calendar, Clock } from 'lucide-react';
import '../styles/RouteInfo.css';

const RouteInfo = ({ filename, targetDateTime }) => {
  const formatDateTime = (isoString) => {
    if (!isoString) return null;
    
    try {
      const date = new Date(isoString);
      return date.toLocaleString('ca-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return null;
    }
  };

  const formattedDate = formatDateTime(targetDateTime);
  const now = new Date();
  const targetDate = targetDateTime ? new Date(targetDateTime) : null;
  const isToday = targetDate && 
    targetDate.getDate() === now.getDate() &&
    targetDate.getMonth() === now.getMonth() &&
    targetDate.getFullYear() === now.getFullYear();

  return (
    <div className="route-info-container fade-in">
      <div className="route-info-card">
        <div className="info-section">
          <div className="info-icon file-icon">
            <FileText size={24} />
          </div>
          <div className="info-content">
            <span className="info-label">Ruta analitzada</span>
            <span className="info-value">{filename || 'Fitxer GPX'}</span>
          </div>
        </div>

        {formattedDate && (
          <div className="info-section">
            <div className="info-icon date-icon">
              <Calendar size={24} />
            </div>
            <div className="info-content">
              <span className="info-label">Sortida prevista</span>
              <div className="date-value-container">
                <span className="info-value">{formattedDate}</span>
                {isToday && <span className="today-badge">Avui</span>}
              </div>
            </div>
          </div>
        )}

        {!formattedDate && (
          <div className="info-section muted">
            <div className="info-icon date-icon">
              <Clock size={24} />
            </div>
            <div className="info-content">
              <span className="info-label">Previsió</span>
              <span className="info-value-small">Properes 12 hores</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RouteInfo;